import { init, GameLoop } from "kontra";
import { $, $$, configCanvas } from "../helpers/index";
import { GameController } from "./game";

let { canvas } = init();

configCanvas(canvas, Math.min(document.body.clientWidth, 900), document.body.clientHeight, 1, "#111111");

const game = new GameController();
game.loadAssets().then(() => {
  game.gameStart();
});

let loop = GameLoop({
  update: function () {
    game.update();
  },
  render: function () {
    game.render();
  }
});

loop.start(); // start the game
